import { Instant } from "@js-joda/core"
import { DeviceVendor } from "./Devices"

export type DeviceType = "BLOOD_GLUCOSE_MONITOR" | "BLOOD_PRESSURE_MONITOR"

export type DeviceOrderStatus =
  | "pending"
  | "shipped"
  | "delivered"
  | "cancelled"
  | "other"
  | "error"

export type DeviceKitType = "blood-pressure-monitor" | "blood-glucose-monitor"

export type DeviceKitItem = {
  name: string
  model: string | null
  sku: string
}

export type DeviceKit = {
  id: string
  vendor: DeviceVendor
  type: DeviceKitType
  name: string
  items: DeviceKitItem[]
}

export type DeviceOrderDto = {
  orderNumber: string
  vendor: DeviceVendor
  vendorOrderId?: string
  type: DeviceType
  serialNumber?: string
  status: DeviceOrderStatus
  carrier?: string
  trackingNumber?: string
  orderCreatedAt: string
  orderDeliveredAt?: string
}

export type DeviceOrder = {
  orderNumber: string
  vendor: DeviceVendor
  vendorOrderId?: string
  type: DeviceType
  serialNumber?: string
  status: DeviceOrderStatus
  carrier?: string
  trackingNumber?: string
  orderCreatedAt: Instant
  orderDeliveredAt?: Instant
}

export const toDeviceOrder = (deviceOrderDto: DeviceOrderDto): DeviceOrder => ({
  ...deviceOrderDto,
  orderCreatedAt: Instant.parse(deviceOrderDto.orderCreatedAt),
  orderDeliveredAt: deviceOrderDto.orderDeliveredAt
    ? Instant.parse(deviceOrderDto.orderDeliveredAt)
    : undefined,
})

export const deviceOrderStatusLabel = (status: DeviceOrderStatus): string => {
  switch (status) {
    case "pending":
      return "Pending"
    case "shipped":
      return "Shipped"
    case "delivered":
      return "Delivered"
    case "cancelled":
      return "Cancelled"
    case "error":
      return "Error"
    case "other":
      return "-"
  }
}
